import axios, { AxiosPromise } from 'axios';

export const FETCH_USER_INFO_DATA = 'FETCH_USER_INFO_DATA';
export const FETCH_USER_INFO_DATA_FULFILLED = `${FETCH_USER_INFO_DATA}_FULFILLED`;
export const FETCH_USER_INFO_DATA_REJECTED = `${FETCH_USER_INFO_DATA}_REJECTED`;

interface AxiosPromiseResponse {
  data: any;
}

interface GetUserInfoDataAction {
  type: string;
  payload: AxiosPromise<AxiosPromiseResponse>;
}

export interface GetUserInfoDataActionResponse {
  type: string;
  payload: AxiosPromiseResponse;
}

export function getUserInfoData(): GetUserInfoDataAction {
  return {
    type: FETCH_USER_INFO_DATA,
    payload: axios.get(`${process.env.REACT_APP_USER_INFO_DATA_SERVICE_ENDPOINT}`)
  };
}
